// GetJobs.Today — i18n dictionaries for 8 launch languages.
export const LANGS = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "hi", label: "हिन्दी", flag: "🇮🇳" },
  { code: "ta", label: "தமிழ்", flag: "🇮🇳" },
  { code: "te", label: "తెలుగు", flag: "🇮🇳" },
  { code: "kn", label: "ಕನ್ನಡ", flag: "🇮🇳" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "zh", label: "简体中文", flag: "🇨🇳" },
];

const en = {
  nav_find_jobs: "Find Jobs",
  nav_find_people: "Find People",
  nav_how: "How it works",
  nav_login: "Log in",
  nav_signup: "Sign up",
  nav_dashboard: "Dashboard",
  nav_profile: "Profile",
  nav_post_job: "Post a Job",
  nav_logout: "Log out",
  nav_admin: "Admin",
  hero_title: "Find Work. Find People. Anywhere.",
  hero_sub: "A global workforce marketplace where people discover opportunities and employers find people who are ready to work.",
  cta_work_title: "I'M LOOKING FOR WORK",
  cta_work_sub: "Create your FREE profile",
  cta_people_title: "I'M LOOKING FOR PEOPLE",
  cta_people_sub: "Post your first 5 jobs FREE",
  available_now: "AVAILABLE NOW",
  available_week: "AVAILABLE THIS WEEK",
  available_date: "AVAILABLE FROM DATE",
  not_available: "NOT AVAILABLE",
  jobs_today: "Jobs Posted Today",
  stat_candidates: "Available Candidates",
  stat_jobs: "Jobs Available",
  stat_countries: "Countries",
  stat_cities: "Cities",
  stat_skills: "Skills",
  stat_employers: "Employers",
  demo_data: "Demo data — launching globally",
  free_for_life: "Free for life",
  view_profile: "View Profile",
  view_job: "View Job",
  apply_now: "Apply Now",
  shortlist: "Shortlist",
  invite: "Invite to Apply",
  contact: "Contact",
  search_placeholder: "Search by title, skill or keyword",
  city_placeholder: "City",
  search: "Search",
  match: "Match",
  sponsored: "SPONSORED",
  profile_strength: "Profile Strength",
  home_rank: "HomeRank",
  free_posts_remaining: "Free posts remaining",
  free_period_left: "Free period left",
  days: "days",
  active_jobs: "Active jobs",
  applications: "Applications",
  shortlisted: "Shortlisted",
  invited: "Invited",
  experience: "experience",
  years: "years",
  share_profile: "Share Profile",
  share_job: "Share Job",
  how_title: "How GetJobs.Today works",
  footer_tagline: "Find Work. Find People. Anywhere.",
  candidates_free: "Candidates: FREE FOR LIFE",
  employers_free: "Employers: First 5 job posts FREE",
  more: "More",
  home: "Home",
};

// Lightweight translations for key UI strings. Non-translated keys fall back to English.
const hi = {
  nav_find_jobs: "नौकरी खोजें", nav_find_people: "लोग खोजें", nav_how: "यह कैसे काम करता है",
  nav_login: "लॉग इन", nav_signup: "साइन अप", nav_dashboard: "डैशबोर्ड", nav_profile: "प्रोफ़ाइल",
  nav_post_job: "नौकरी पोस्ट करें", nav_logout: "लॉग आउट",
  hero_title: "काम ढूँढें। लोग ढूँढें। कहीं भी।",
  hero_sub: "एक वैश्विक कार्यबल बाज़ार जहाँ लोग अवसर खोजते हैं और नियोक्ता काम के लिए तैयार लोगों को पाते हैं।",
  cta_work_title: "मुझे काम चाहिए", cta_work_sub: "अपनी मुफ़्त प्रोफ़ाइल बनाएँ",
  cta_people_title: "मुझे लोग चाहिए", cta_people_sub: "पहली 5 नौकरियाँ मुफ़्त पोस्ट करें",
  available_now: "अभी उपलब्ध", available_week: "इस सप्ताह उपलब्ध", available_date: "तारीख़ से उपलब्ध",
  not_available: "उपलब्ध नहीं", jobs_today: "आज पोस्ट की गई नौकरियाँ",
  stat_candidates: "उपलब्ध उम्मीदवार", stat_jobs: "उपलब्ध नौकरियाँ", stat_countries: "देश",
  stat_cities: "शहर", stat_skills: "कौशल", stat_employers: "नियोक्ता",
  search: "खोजें", apply_now: "अभी आवेदन करें", view_profile: "प्रोफ़ाइल देखें",
  free_for_life: "जीवन भर मुफ़्त", home: "होम", more: "और",
};
const ta = {
  nav_find_jobs: "வேலை தேடு", nav_find_people: "நபர்களை தேடு", nav_login: "உள்நுழைய",
  nav_signup: "பதிவு செய்", nav_dashboard: "டாஷ்போர்டு", nav_profile: "சுயவிவரம்",
  nav_post_job: "வேலை இடு", nav_logout: "வெளியேறு",
  hero_title: "வேலை தேடு. நபர்களை தேடு. எங்கும்.",
  hero_sub: "மக்கள் வாய்ப்புகளைக் கண்டறியும், முதலாளிகள் வேலைக்குத் தயாராக உள்ளவர்களைக் கண்டறியும் உலகளாவிய பணியாளர் சந்தை.",
  cta_work_title: "எனக்கு வேலை வேண்டும்", cta_work_sub: "இலவச சுயவிவரம் உருவாக்கு",
  cta_people_title: "எனக்கு நபர்கள் வேண்டும்", cta_people_sub: "முதல் 5 வேலைகள் இலவசம்",
  available_now: "இப்போது கிடைக்கும்", available_week: "இந்த வாரம்", not_available: "கிடைக்காது",
  jobs_today: "இன்று இடப்பட்ட வேலைகள்", stat_candidates: "கிடைக்கும் விண்ணப்பதாரர்கள்",
  stat_jobs: "கிடைக்கும் வேலைகள்", search: "தேடு", apply_now: "விண்ணப்பிக்க", home: "முகப்பு", more: "மேலும்",
};
const te = {
  nav_find_jobs: "ఉద్యోగాలు", nav_find_people: "వ్యక్తులు", nav_login: "లాగిన్", nav_signup: "సైన్ అప్",
  nav_dashboard: "డాష్‌బోర్డ్", nav_profile: "ప్రొఫైల్", nav_post_job: "ఉద్యోగం పోస్ట్", nav_logout: "లాగ్ అవుట్",
  hero_title: "పని కనుగొనండి. వ్యక్తులను కనుగొనండి. ఎక్కడైనా.",
  cta_work_title: "నాకు పని కావాలి", cta_work_sub: "ఉచిత ప్రొఫైల్ సృష్టించండి",
  cta_people_title: "నాకు వ్యక్తులు కావాలి", cta_people_sub: "మొదటి 5 ఉద్యోగాలు ఉచితం",
  available_now: "ఇప్పుడు అందుబాటులో", jobs_today: "ఈరోజు పోస్ట్ చేసిన ఉద్యోగాలు",
  search: "వెతకండి", apply_now: "దరఖాస్తు చేయండి", home: "హోమ్", more: "మరిన్ని",
};
const kn = {
  nav_find_jobs: "ಕೆಲಸ ಹುಡುಕಿ", nav_find_people: "ಜನರನ್ನು ಹುಡುಕಿ", nav_login: "ಲಾಗಿನ್", nav_signup: "ಸೈನ್ ಅಪ್",
  nav_dashboard: "ಡ್ಯಾಶ್‌ಬೋರ್ಡ್", nav_profile: "ಪ್ರೊಫೈಲ್", nav_post_job: "ಕೆಲಸ ಪೋಸ್ಟ್", nav_logout: "ಲಾಗ್ ಔಟ್",
  hero_title: "ಕೆಲಸ ಹುಡುಕಿ. ಜನರನ್ನು ಹುಡುಕಿ. ಎಲ್ಲಿಯಾದರೂ.",
  cta_work_title: "ನನಗೆ ಕೆಲಸ ಬೇಕು", cta_work_sub: "ಉಚಿತ ಪ್ರೊಫೈಲ್ ರಚಿಸಿ",
  cta_people_title: "ನನಗೆ ಜನರು ಬೇಕು", cta_people_sub: "ಮೊದಲ 5 ಕೆಲಸಗಳು ಉಚಿತ",
  available_now: "ಈಗ ಲಭ್ಯ", jobs_today: "ಇಂದು ಪೋಸ್ಟ್ ಮಾಡಿದ ಕೆಲಸಗಳು",
  search: "ಹುಡುಕಿ", apply_now: "ಅರ್ಜಿ ಸಲ್ಲಿಸಿ", home: "ಮುಖಪುಟ", more: "ಇನ್ನಷ್ಟು",
};
const ru = {
  nav_find_jobs: "Найти работу", nav_find_people: "Найти людей", nav_how: "Как это работает",
  nav_login: "Войти", nav_signup: "Регистрация", nav_dashboard: "Панель", nav_profile: "Профиль",
  nav_post_job: "Разместить вакансию", nav_logout: "Выйти",
  hero_title: "Найдите работу. Найдите людей. Где угодно.",
  hero_sub: "Глобальный рынок труда, где люди находят возможности, а работодатели — готовых работать специалистов.",
  cta_work_title: "Я ИЩУ РАБОТУ", cta_work_sub: "Создайте БЕСПЛАТНЫЙ профиль",
  cta_people_title: "Я ИЩУ ЛЮДЕЙ", cta_people_sub: "Первые 5 вакансий БЕСПЛАТНО",
  available_now: "ДОСТУПЕН СЕЙЧАС", available_week: "ДОСТУПЕН НА ЭТОЙ НЕДЕЛЕ", not_available: "НЕ ДОСТУПЕН",
  jobs_today: "Вакансии за сегодня", stat_candidates: "Доступные кандидаты", stat_jobs: "Доступные вакансии",
  stat_countries: "Страны", stat_cities: "Города", search: "Поиск", apply_now: "Откликнуться",
  view_profile: "Профиль", home: "Главная", more: "Ещё",
};
const es = {
  nav_find_jobs: "Buscar empleo", nav_find_people: "Buscar personas", nav_how: "Cómo funciona",
  nav_login: "Iniciar sesión", nav_signup: "Registrarse", nav_dashboard: "Panel", nav_profile: "Perfil",
  nav_post_job: "Publicar empleo", nav_logout: "Cerrar sesión",
  hero_title: "Encuentra trabajo. Encuentra personas. En cualquier lugar.",
  hero_sub: "Un mercado laboral global donde las personas descubren oportunidades y los empleadores encuentran gente lista para trabajar.",
  cta_work_title: "BUSCO TRABAJO", cta_work_sub: "Crea tu perfil GRATIS",
  cta_people_title: "BUSCO PERSONAS", cta_people_sub: "Publica tus primeros 5 empleos GRATIS",
  available_now: "DISPONIBLE AHORA", available_week: "DISPONIBLE ESTA SEMANA", not_available: "NO DISPONIBLE",
  jobs_today: "Empleos publicados hoy", stat_candidates: "Candidatos disponibles", stat_jobs: "Empleos disponibles",
  stat_countries: "Países", stat_cities: "Ciudades", search: "Buscar", apply_now: "Postular ahora",
  view_profile: "Ver perfil", home: "Inicio", more: "Más",
};
const zh = {
  nav_find_jobs: "找工作", nav_find_people: "找人才", nav_how: "运作方式", nav_login: "登录",
  nav_signup: "注册", nav_dashboard: "仪表板", nav_profile: "个人资料", nav_post_job: "发布职位", nav_logout: "退出",
  hero_title: "找工作。找人才。无处不在。",
  hero_sub: "一个全球劳动力市场，人们发现机会，雇主找到随时可以工作的人才。",
  cta_work_title: "我在找工作", cta_work_sub: "创建免费个人资料",
  cta_people_title: "我在找人才", cta_people_sub: "前 5 个职位免费发布",
  available_now: "现在可用", available_week: "本周可用", not_available: "不可用",
  jobs_today: "今日发布的职位", stat_candidates: "可用候选人", stat_jobs: "可用职位",
  stat_countries: "国家", stat_cities: "城市", search: "搜索", apply_now: "立即申请",
  view_profile: "查看资料", home: "首页", more: "更多",
};

export const translations = { en, hi, ta, te, kn, ru, es, zh };
